'use client'

import { Divider, Spacer } from '@vinted/web-ui'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { ProfileCountdownBanner } from '@marketplace-web/marketing-campaigns/closet-countdown-feature'

import { ProfileUserDto } from '@marketplace-web/profile/profile-data'

import ProfileVisitorBanners from './ProfileVisitorBanners'
import ProfileOwnerBanners from './ProfileOwnerBanners'
import { isDateInTheFuture } from '../../../utils/date'

type Props = {
  viewingSelf: boolean
  showActions: boolean
  user: ProfileUserDto | null | undefined
  showBundles: boolean
  userId: number
}

const ProfileBanners = ({ showActions, viewingSelf, user, showBundles, userId }: Props) => {
  const breakpoints = useBreakpoint()

  const renderCountDownBanner = () => {
    const {
      is_favourite: isFollowed,
      login: username,
      closet_countdown_end_date: closetCountdownEndDate,
    } = user || {}

    if (!closetCountdownEndDate || !isDateInTheFuture(closetCountdownEndDate)) return null

    const bottomElement = breakpoints.tabletsUp ? <Spacer size={Spacer.Size.XLarge} /> : <Divider />

    return (
      <ProfileCountdownBanner
        userId={userId}
        username={username}
        isFollowed={isFollowed}
        showActions={showActions}
        viewingSelf={viewingSelf}
        endDate={closetCountdownEndDate}
        bottomElement={viewingSelf ? bottomElement : undefined}
      />
    )
  }

  return viewingSelf ? (
    <ProfileOwnerBanners renderCountDownBanner={renderCountDownBanner} />
  ) : (
    <ProfileVisitorBanners
      user={user}
      showBundles={showBundles}
      userId={userId}
      renderCountDownBanner={renderCountDownBanner}
    />
  )
}

export default ProfileBanners
